/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboardingprofiletitle2Inputs */

const en_onboardingprofiletitle2 = /** @type {(inputs: Onboardingprofiletitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do you use Pulsify?`)
};

const de_onboardingprofiletitle2 = /** @type {(inputs: Onboardingprofiletitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie nutzt du Pulsify?`)
};

/**
* | output |
* | --- |
* | "How do you use Pulsify?" |
*
* @param {Onboardingprofiletitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const onboardingprofiletitle2 = /** @type {((inputs?: Onboardingprofiletitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboardingprofiletitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboardingprofiletitle2(inputs)
	return de_onboardingprofiletitle2(inputs)
});
export { onboardingprofiletitle2 as "onboardingProfileTitle" }